import { useState } from 'react';
import { readClaimToken } from '@discovr/common';

export const SHOPIFY_INSTALL_RETURN_PATH = '/integrations?shopify=installed';

export function pendingClaimReturnPath(): string | null {
  return readClaimToken() ? SHOPIFY_INSTALL_RETURN_PATH : null;
}

export function usePendingClaimReturnPath(): string | null {
  const [path] = useState(pendingClaimReturnPath);
  return path;
}
